
import React, { useState, useEffect } from "react";
import { Col, Row, Offcanvas, Card } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { Inward365 } from "./Group To Party View/Inward365";
import { InwardDetail } from "./Group To Party View/InwardDetail";
import { InwardQuality } from "./Group To Party View/InwardQuality";
import { Billing365 } from "./Group To Party View/Billing365";
import { BillingDetail } from "./Group To Party View/BillingDetail";
import { BillingQuality } from "./Group To Party View/BillingQuality";
import { Balance365 } from "./Group To Party View/Balance365";
import { BalanceDetail } from "./Group To Party View/BalanceDetail";
import { BalanceQuality } from "./Group To Party View/BalanceQuality";
import { FilterBox } from "../../../components/FilterBox/FilterBox";
import { CiBank } from "react-icons/ci";
import { Monitor } from 'lucide-react';
import { InwParty365, MasterFilterMain, resetInwParty365, resetMasterFilter } from "../../../Redux/Slice/Grey/PartyProfile/PartyProfileSlice";
import {
    FiUsers,
    FiHash,
    FiHome,
    FiUser,
    FiPhone,
    FiMail,
    FiAlertTriangle
} from "react-icons/fi";

import {
    MdBusiness,
    MdCreditCard,
    MdAccountBalance,
    MdNumbers,
    MdLocalPhone
} from "react-icons/md";
import {
    IoLocationOutline,
    IoBusinessOutline,
} from "react-icons/io5";
import userImg from "../../../img/DynamicSoftware.png";
import { Loader } from "../../../components/Loader/Loader";
import { useTheme } from "../../../Themecontext/Themecontext";


export const GroupToAccount = ({ showFilter, handleClose }) => {

    const dispatch = useDispatch()


    const [activePage, setActivePage] = useState("Inward365");
    const [hoverIndex, setHoverIndex] = useState(null);

    const { Colourdata, mainFilterData } = useSelector((state) => state.ClientLogin);
    const { MasterFilterData, masterLoading, InwParty365Data } = useSelector((state) => state.PartyProfileSlice);


    const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
    const iscolourDark = Colourdata?.data?.find(
        (el) => el.ExeName === "GRAYDARKNEW",
    );

    const { theme } = useTheme();
    const isdark = theme;





    const [filters, setFilters] = useState({
        production: "",
        account: "",
    });

    const [search, setSearch] = useState({
        production: "",
        account: "",
    });

    const productionGroups =
        mainFilterData?.production_Group_Master_List?.map((item) => ({
            label: item.ProductionGroupMstName,
            value: item.ProductionGroupMstID,
        })) || [];

    const accountGroups =
        MasterFilterData?.Data?.map((item) => ({
            label: item.AcName,
            value: item.AcID,
        })) || [];

    const toggleItem = (type, item) => {
        setFilters((prev) => {
            const newValue = prev[type] === item.value ? "" : item.value;
            if (type === "production") {
                dispatch(MasterFilterMain(newValue ? newValue.toString() : ""));
            }

            if (type === "account") {
                dispatch(resetInwParty365())
                dispatch(InwParty365({
                    selectedIds: prev.production ? prev.production.toString() : "",
                    id: newValue ? newValue.toString() : ""
                }));
            }

            return {
                ...prev,
                [type]: newValue
            };
        });
    };

    const selectAll = (type) => {
        setFilters((prev) => {
            const newValue = "";
            return {
                ...prev,
                [type]: newValue
            };
        });
    };

    const handleSearch = (type, value) => {
        setSearch((prev) => ({
            ...prev,
            [type]: value,
        }));
    };


    const renderPage = () => {
        const commonProps = {
            selectedProduction: filters.production,
            selectedAccount: filters.account,
        }


        switch (activePage) {
            case "Inward365":
                return <div><Inward365 {...commonProps} /></div>;

            case "InwardQuality":
                return <div> <InwardQuality {...commonProps} /></div>;

            case "InwardDetail":
                return <div><InwardDetail {...commonProps} /></div>;

            case "Billing365":
                return <div><Billing365 {...commonProps} /></div>;

            case "BillingQuality":
                return <div><BillingQuality {...commonProps} /></div>;

            case "BillingDetail":
                return <div><BillingDetail {...commonProps} /></div>;

            case "Balance365":
                return <div><Balance365 {...commonProps} /></div>;

            case "BalanceQuality":
                return <div><BalanceQuality {...commonProps} /></div>;

            case "BalanceDetail":
                return <div><BalanceDetail {...commonProps} /></div>;

            default:
                return null;
        }
    };

    const showAccountCardPages = [
        "InwardQuality",
        "InwardDetail",
        "Billing365",
        "BillingDetail",
        "BillingQuality",
        "Balance365",
        "BalanceQuality",
        "BalanceDetail"
    ];

    const showAccountCard = showAccountCardPages.includes(activePage);


    const boxData = [
        { label: "GROUP", value: InwParty365Data?.InwPartyDtl?.[0]?.GroupName || "-", icon: <FiUsers size={22} /> },
        { label: "GST NO", value: InwParty365Data?.InwPartyDtl?.[0]?.GSTNO || "-", icon: <FiHash size={22} /> },

        { label: "DEPARTMENT", value: InwParty365Data?.InwPartyDtl?.[0]?.Department || "-", icon: <MdBusiness size={22} /> },
        { label: "PAN NO", value: InwParty365Data?.InwPartyDtl?.[0]?.PanNo || "-", icon: <MdCreditCard size={22} /> },

        { label: "CONTACT PERSON 1", value: InwParty365Data?.InwPartyDtl?.[0]?.ContactPerson1 || "0", icon: <FiUser size={22} /> },
        { label: "MOBILE NO", value: InwParty365Data?.InwPartyDtl?.[0]?.MobilNO || "-", icon: <FiPhone size={22} /> },

        { label: "CONTACT PERSON 2", value: InwParty365Data?.InwPartyDtl?.[0]?.ContactPerson2 || "0", icon: <FiUser size={22} /> },
        { label: "MOBILE NO 1", value: InwParty365Data?.InwPartyDtl?.[0]?.MobilNO1 || "-", icon: <MdLocalPhone size={22} /> },

        { label: "EMAIL ID", value: InwParty365Data?.InwPartyDtl?.[0]?.EmailID || "-", icon: <FiMail size={22} /> },
        { label: "MSME NO", value: InwParty365Data?.InwPartyDtl?.[0]?.MSMENO || "-", icon: <MdNumbers size={22} /> },

        { label: "TELEPHONE NO", value: InwParty365Data?.InwPartyDtl?.[0]?.TelephoneNO || "-", icon: <FiPhone size={22} /> },
        { label: "EMERGENCY NO", value: InwParty365Data?.InwPartyDtl?.[0]?.EmergencyNO || "-", icon: <FiAlertTriangle size={22} /> },

        { label: "BANK DETAILS", value: InwParty365Data?.InwPartyDtl?.[0]?.BankName || "0", icon: <MdAccountBalance size={22} /> },
        { label: "IFSC CODE", value: InwParty365Data?.InwPartyDtl?.[0]?.IFSCCode || "-", icon: <FiHash size={22} /> },

        { label: "ACCOUNT NO", value: InwParty365Data?.InwPartyDtl?.[0]?.AccountNo || "-", icon: <MdCreditCard size={22} /> }
    ];

    const dummyData = {
        AcName: InwParty365Data?.InwPartyDtl?.[0]?.AcName || "",
        GSTNO: InwParty365Data?.InwPartyDtl?.[0]?.GSTNO || "",
        Address1: InwParty365Data?.InwPartyDtl?.[0]?.Address1 || "",
    };

    if (!mainFilterData) {
        return (
            <div className="flex justify-center items-center  text-xl text-green-700">
                <Loader />
            </div>
        );
    }

    if (masterLoading) {
        return (
            <div className="flex justify-center items-center h-screen text-xl text-green-700">
                <Loader />
            </div>
        );
    }

    const renderAccountInfoCard = () => {

        return (
            <div>
                <div
                    style={{
                        borderRadius: "12px",
                        overflow: "hidden",
                        background:
                            isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour3,
                        border: `1px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    }}
                >

                    <div
                        style={{
                            padding: "20px",
                            background:
                                isdark === "light"
                                    ? iscolour?.Colour1
                                    : iscolourDark?.Colour3,
                            borderBottom: `1px solid ${isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour6
                                }`,
                        }}
                    >
                        <Row className="align-items-center">
                            <Col xs={12}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "20px",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {/* IMAGE */}
                                    <img
                                        src={userImg}
                                        alt="Customer"
                                        style={{
                                            width: "95px",
                                            height: "95px",
                                            borderRadius: "20px",
                                            border: `2px solid ${isdark === "light"
                                                ? iscolour?.Colour5
                                                : iscolourDark?.Colour6
                                                }`,
                                        }}
                                    />

                                    {/* TEXT */}
                                    <div style={{ flex: 1 }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                gap: "10px",
                                            }}
                                        >
                                            {/* 🔥 LEFT SIDE (NAME + ADDRESS together NO GAP) */}
                                            <div style={{ flex: 1 }}>
                                                <div
                                                    style={{
                                                        color:
                                                            isdark === "light"
                                                                ? iscolour?.Colour11
                                                                : iscolourDark?.Colour2,
                                                        fontWeight: "700",
                                                        fontSize: "18px",
                                                        lineHeight: "20px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    {dummyData.AcName}
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "6px",
                                                        marginTop: "2px",
                                                    }}
                                                >
                                                    <IoLocationOutline
                                                        style={{
                                                            fontSize: "14px",
                                                            color:
                                                                isdark === "light"
                                                                    ? iscolour?.Colour11
                                                                    : iscolourDark?.Colour4,
                                                        }}
                                                    />

                                                    <span
                                                        style={{
                                                            fontSize: "13px",
                                                            lineHeight: "16px",
                                                            color:
                                                                isdark === "light"
                                                                    ? iscolour?.Colour11
                                                                    : iscolourDark?.Colour4,
                                                        }}
                                                    >
                                                        {dummyData.Address1}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* 🔥 RIGHT SIDE GST (same row FIXED) */}
                                            <div
                                                style={{
                                                    flexShrink: 0,
                                                    minWidth: "220px",
                                                    padding: "10px 14px",
                                                    borderRadius: "12px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    whiteSpace: "nowrap",

                                                    background: "rgba(255, 255, 255, 0.22)",

                                                    backdropFilter: "blur(14px)",
                                                    WebkitBackdropFilter: "blur(14px)",
                                                    boxShadow:
                                                        "rgba(117, 82, 18, 0.12) 0px 10px 30px -10px, rgba(255, 255, 255, 0.6) 0px 1px 0px inset",
                                                }}
                                            >
                                                <IoBusinessOutline
                                                    style={{
                                                        fontSize: "18px",
                                                        color:
                                                            isdark === "light"
                                                                ? iscolour?.Colour5
                                                                : iscolourDark?.Colour2,
                                                    }}
                                                />

                                                <div
                                                    style={{
                                                        color:
                                                            isdark === "light"
                                                                ? iscolour?.Colour5
                                                                : iscolourDark?.Colour2,
                                                    }}
                                                >
                                                    <div style={{ fontSize: "11px", opacity: 0.8 }}>
                                                        TAX IDENTIFICATION
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontWeight: "700",
                                                            letterSpacing: "1px",
                                                            fontSize: "15px",
                                                        }}
                                                    >
                                                        {dummyData.GSTNO}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    {/* 🔽 BOTTOM SECTION */}
                    <div style={{
                        padding: "12px",
                        background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour3,
                    }}>
                        <Row className="g-2">
                            {boxData.map((item, i) => (
                                <Col xl={4} lg={4} md={6} sm={6} xs={12} key={i}>
                                    <div
                                        onMouseEnter={() => setHoverIndex(i)}
                                        onMouseLeave={() => setHoverIndex(null)}
                                        style={{
                                            borderRadius: "8px",
                                            padding: "10px",
                                            height: "70px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                            background:
                                                isdark === "light"
                                                    ? iscolour?.Colour5
                                                    : iscolourDark?.Colour8,
                                            border: `1px solid ${isdark === "light"
                                                ? iscolour?.Colour4
                                                : iscolourDark?.Colour6}`,
                                            transition: "border-color 0.2s ease, background 0.2s ease",
                                        }}
                                    >
                                        {/* Icon */}
                                        <div
                                            style={{
                                                fontSize: "18px",
                                                minWidth: "38px",
                                                height: "38px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color:
                                                    isdark === "light"
                                                        ? iscolour?.Colour5
                                                        : "#ffffff",
                                                background:
                                                    isdark === "light"
                                                        ? iscolour?.Colour6
                                                        : iscolourDark?.Colour1,
                                                borderRadius: "8px",
                                                flexShrink: 0,
                                            }}
                                        >
                                            {item.icon}
                                        </div>

                                        {/* Text */}
                                        <div style={{ flex: 1, overflow: "hidden" }}>
                                            <div
                                                style={{
                                                    fontSize: "11px",
                                                    fontWeight: "600",
                                                    letterSpacing: "0.5px",
                                                    textTransform: "uppercase",
                                                    color:
                                                        isdark === "light"
                                                            ? iscolour?.Colour6
                                                            : iscolourDark?.Colour4,
                                                    marginBottom: "2px",
                                                }}
                                            >
                                                {item.label}
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: "13px",
                                                    fontWeight: "700",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    color:
                                                        isdark === "light"
                                                            ? iscolour?.Colour10
                                                            : iscolourDark?.Colour2,
                                                }}
                                            >
                                                {item.value}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </div>
            </div>
        );
    };

    const formatIndianRupee = (amount) => {
        const num = Number(amount);
        if (isNaN(num)) return "0.00";
        return new Intl.NumberFormat("en-IN", {
            currency: "INR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(num);
    };


    const showAccountSummaryCard = [
        "Inward365"
    ];

    const showAccountSummary = showAccountSummaryCard.includes(activePage);

    const AccountSummaryCard = () => {
        return (
            <>

                <Row className="mb-3">
                    <Col>
                        <div
                            style={{
                                background: isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour7,
                                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2,
                                border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6}`,
                                padding: "15px 20px",
                                borderRadius: "25px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <div
                                    style={{
                                        height: "8px",
                                        width: "8px",
                                        background: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
                                        borderRadius: "50%",
                                    }}
                                />
                                <span style={{ fontSize: "15px", fontWeight: 500 }}>
                                    {InwParty365Data?.InwPartyDtl?.[0]?.AcName}
                                </span>
                            </div>

                            {/* <span style={{ fontSize: "12px", opacity: 0.7 }}>
                                ID: #SYS-8829
                            </span> */}
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col
                        lg={3}
                        className="mb-3"
                        style={{ display: "flex", justifyContent: "center" }}
                    >
                        <div
                            style={{
                                width: "100%",
                                height: "100%",
                                // minHeight:"260px",
                                // minWidth:"260px",
                                borderRadius: "30px",
                                background: "linear-gradient(145deg, #0f3d2e, #0b2f25)",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "inset 0 0 20px rgba(255,255,255,0.05)",
                                position: "relative",
                            }}
                        >
                            {/* Icon Box */}
                            <div
                                style={{
                                    background: "rgba(255,255,255,0.05)",
                                    padding: "18px",
                                    borderRadius: "20px",
                                    marginBottom: "20px",
                                }}
                            >
                                <Monitor size={40} style={{ color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2 }} />
                            </div>

                            {/* Title */}
                            <div
                                style={{
                                    textAlign: "center",
                                    color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2,
                                    lineHeight: "1.2",
                                }}
                            >
                                <div style={{ fontSize: "20px", fontWeight: "800" }}>
                                    DYNAMIC
                                </div>
                                <div style={{ fontSize: "12px", opacity: 0.8 }}>
                                    SOFTLINK
                                </div>
                            </div>


                        </div>
                    </Col>

                    <Col lg={9}>
                        <Row >
                            <Col lg={12} className="mb-3">
                                <Card
                                    style={{
                                        borderRadius: "25px",
                                        border: `1px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour12} `,
                                        background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour11,
                                        overflow: "hidden",
                                    }}
                                >
                                    {/* Header strip */}
                                    <div
                                        style={{
                                            background: isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour11,
                                            borderBottom: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour12}`,
                                            padding: "12px 20px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <span style={{ fontWeight: 600, color: isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour1, }}>
                                            ACCOUNT GROUP
                                        </span>

                                        <span
                                            style={{
                                                background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour6,
                                                padding: "5px 15px",
                                                borderRadius: "20px",
                                                fontSize: "12px",
                                                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4
                                            }}
                                        >
                                            {InwParty365Data?.InwPartyDtl?.[0]?.Department}
                                        </span>
                                    </div>

                                    <Card.Body style={{ padding: "20px" }}>
                                        <Row>
                                            {[
                                                {
                                                    title: "OPENING", value: formatIndianRupee(InwParty365Data?.InwPartyDtl[0]?.Opening), active: true
                                                },
                                                { title: "INWARD", value: formatIndianRupee(InwParty365Data?.InwPartyDtl[0]?.Inward) },
                                                { title: "SHORTAGE", value: formatIndianRupee(InwParty365Data?.InwPartyDtl[0]?.ShortageMeter) },
                                                { title: "ELONGATION", value: formatIndianRupee(InwParty365Data?.InwPartyDtl[0]?.LongeshionMeter) },
                                            ].map((item, i) => (
                                                <Col xs={6} md={3} key={i} >
                                                    <div
                                                        style={{
                                                            background: isdark === "light" ? "#e7ecea" : iscolourDark?.Colour7,
                                                            borderRadius: "18px",
                                                            padding: "18px 10px",
                                                            textAlign: "center",
                                                            // border:
                                                            //     "1.5px solid #9fd3b4"
                                                            // ,
                                                        }}
                                                    >
                                                        <div style={{ fontSize: "14px", color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4 }}>
                                                            {item.title}
                                                        </div>

                                                        <div
                                                            style={{
                                                                fontSize: "18px",
                                                                fontWeight: 700,
                                                                color: isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour1,
                                                                marginTop: "6px",
                                                            }}
                                                        >
                                                            {item.value}
                                                        </div>

                                                        <div
                                                            style={{
                                                                height: "6px",
                                                                width: "6px",
                                                                background: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
                                                                borderRadius: "50%",
                                                                margin: "10px auto 0",
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                            ))}
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col lg={12} className="mb-3">
                                <Card
                                    style={{
                                        borderRadius: "25px",
                                        border: `1px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour12} `,
                                        background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour11,
                                        overflow: "hidden",
                                    }}
                                >
                                    {/* Header strip */}
                                    <div
                                        style={{
                                            background: isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour11,
                                            borderBottom: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour12}`,
                                            padding: "12px 20px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <span style={{ fontWeight: 600, color: isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour1, }}>
                                            PROD. GROUP
                                        </span>

                                        <span
                                            style={{
                                                background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour6,
                                                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour1,
                                                padding: "5px 15px",
                                                borderRadius: "20px",
                                                fontSize: "12px",
                                            }}
                                        >
                                            {InwParty365Data?.InwPartyDtl?.[0]?.GroupName}
                                        </span>
                                    </div>

                                    <Card.Body style={{ padding: "20px" }}>
                                        <Row>
                                            <Col >
                                                <div
                                                    style={{
                                                        background: isdark === "light" ? "#e7ecea" : iscolourDark?.Colour7,
                                                        borderRadius: "18px 10px",
                                                        padding: "20px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <div style={{ fontSize: "14px", color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4 }}>
                                                        DELIVERY
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "19px",
                                                            fontWeight: 700,
                                                            color: isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour1,
                                                            marginTop: "6px",
                                                        }}
                                                    >
                                                        {formatIndianRupee(InwParty365Data?.InwPartyDtl[0]?.Delivery)}
                                                    </div>

                                                    <div
                                                        style={{
                                                            height: "4px",
                                                            width: "40px",
                                                            background: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
                                                            borderRadius: "10px",
                                                            margin: "10px auto 0",
                                                        }}
                                                    />
                                                </div>
                                            </Col>

                                            <Col>
                                                <div
                                                    style={{
                                                        background: isdark === "light" ? "#e7ecea" : iscolourDark?.Colour7,
                                                        borderRadius: "18px 10px",
                                                        padding: "20px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <div style={{ fontSize: "14px", color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4 }}>
                                                        BALANCE
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "18px",
                                                            fontWeight: 700,
                                                            color: isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour1,
                                                            marginTop: "6px",
                                                        }}
                                                    >
                                                        {formatIndianRupee(InwParty365Data?.InwPartyDtl[0]?.Balance)}
                                                    </div>

                                                    <div
                                                        style={{
                                                            height: "4px",
                                                            width: "40px",
                                                            background: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
                                                            borderRadius: "10px",
                                                            margin: "10px auto 0",
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row >
            </>
        );
    };




    const getBtnStyle = (page) => {
        const isActive = activePage === page;

        return {
            border: `2px solid ${isdark === "light"
                ? iscolour?.Colour1
                : iscolourDark?.Colour12
                }`,
            background: isActive
                ? (isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3)
                : (isdark === "light"
                    ? iscolour?.Colour5  // inactive bg
                    : iscolourDark?.Colour6),
            color: isActive
                ? (isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour2)
                : (isdark === "light"
                    ? iscolour?.Colour2
                    : iscolourDark?.Colour2),
            padding: "10px",
            borderRadius: "10px",
            fontWeight: "600",
            transition: "0.3s"
        };
    };



    return (
        <div className="pageContainer">
            <Row >

                {/* LEFT FILTER */}
                <Col xl={3} lg={4} md={12} className="mb-3 d-none d-lg-block">
                    <div style={{ flexDirection: "column", gap: "15px", display: "flex" }} >
                        {/* PRODUCTION FILTER */}
                        <FilterBox
                            title="Production Group"
                            items={productionGroups}
                            search={search.production}
                            setSearch={(val) => handleSearch("production", val)}
                            selectedItems={
                                filters.production ? [filters.production] : []
                            }
                            toggleItem={(item) => toggleItem("production", item)}
                            selectAll={() => selectAll("production", productionGroups)}
                            isMulti={false}
                        />

                        {/* ACCOUNT FILTER */}
                        {filters.production && (
                            <FilterBox
                                title="Account Name"
                                items={accountGroups}
                                search={search.account}
                                setSearch={(val) => handleSearch("account", val)}
                                selectedItems={
                                    filters.account ? [filters.account] : []
                                }
                                toggleItem={(item) => toggleItem("account", item)}
                                selectAll={() => selectAll("account", accountGroups)}
                                isMulti={false}
                            />
                        )}
                    </div>
                </Col>

                <Offcanvas show={showFilter} onHide={handleClose} placement="start" className="d-lg-none">
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Filters</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <div style={{ flexDirection: "column", gap: "15px", display: "flex" }} >

                            {/* PRODUCTION FILTER */}
                            <FilterBox
                                title="Production Group"
                                items={productionGroups}
                                search={search.production}
                                setSearch={(val) => handleSearch("production", val)}
                                selectedItems={
                                    filters.production ? [filters.production] : []
                                }
                                toggleItem={(item) => toggleItem("production", item)}
                                selectAll={() => selectAll("production", productionGroups)}
                                isMulti={false}
                            />

                            {/* ACCOUNT FILTER */}
                            {filters.production && (
                                <FilterBox
                                    title="Account Name"
                                    items={accountGroups}
                                    search={search.account}
                                    setSearch={(val) => handleSearch("account", val)}
                                    selectedItems={
                                        filters.account ? [filters.account] : []
                                    }
                                    toggleItem={(item) => toggleItem("account", item)}
                                    selectAll={() => selectAll("account", accountGroups)}
                                    isMulti={false}
                                />
                            )}

                        </div>
                    </Offcanvas.Body>
                </Offcanvas>

                {/* RIGHT SIDE */}
                <Col xl={9} lg={8} md={12}>

                    <Row >

                        {/* INWARD */}
                        <Col lg={4} md={6} sm={12}>
                            <div
                                className="p-3 h-100"
                                style={{
                                    border: `2px solid ${isdark === "light"
                                        ? iscolour?.Colour8
                                        : iscolourDark?.Colour12
                                        }`,
                                    background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                                    borderRadius: "12px",
                                }}
                            >

                                <div
                                    className="text-center mb-3"
                                    style={{
                                        background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
                                        color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2,
                                        padding: "12px",
                                        borderRadius: "12px",
                                        fontWeight: "700"
                                    }}
                                >
                                    INWARD
                                </div>

                                <button
                                    onClick={() => setActivePage("Inward365")}
                                    className="w-100 mb-2 hover-scale-btn"
                                    style={getBtnStyle("Inward365")}
                                >
                                    INWARD 365
                                </button>
                                <button
                                    onClick={() => setActivePage("InwardQuality")}
                                    className="w-100 mb-2 hover-scale-btn"
                                    style={getBtnStyle("InwardQuality")}
                                >
                                    INW. QUALITY
                                </button>

                                <button
                                    onClick={() => setActivePage("InwardDetail")}
                                    className="w-100 hover-scale-btn"
                                    style={getBtnStyle("InwardDetail")}
                                >
                                    INWARD DETAIL
                                </button>


                            </div>
                        </Col>

                        {/* DELIVERY */}
                        <Col lg={4} md={6} sm={12} >
                            <div
                                className="p-3 h-100 "
                                style={{
                                    border: `2px solid ${isdark === "light"
                                        ? iscolour?.Colour8
                                        : iscolourDark?.Colour12
                                        }`,
                                    background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                                    borderRadius: "18px",
                                }}
                            >

                                <div
                                    className="text-center mb-3"
                                    style={{
                                        background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
                                        color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2,
                                        padding: "12px",
                                        borderRadius: "12px",
                                        fontWeight: "700"
                                    }}
                                >
                                    DELIVERY
                                </div>

                                <button
                                    onClick={() => setActivePage("Billing365")}
                                    className="w-100 mb-2 hover-scale-btn"
                                    style={getBtnStyle("Billing365")}
                                >
                                    BILLING 365
                                </button>

                                <button
                                    onClick={() => setActivePage("BillingQuality")}
                                    className="w-100 mb-2 hover-scale-btn"
                                    style={getBtnStyle("BillingQuality")}
                                >
                                    BILLING QTY
                                </button>

                                <button
                                    onClick={() => setActivePage("BillingDetail")}
                                    className="w-100 hover-scale-btn"
                                    style={getBtnStyle("BillingDetail")}
                                >
                                    BILLING DETAIL
                                </button>

                            </div>
                        </Col>

                        {/* BALANCE */}
                        <Col lg={4} md={6} sm={12} >
                            <div
                                className="p-3 h-100"
                                style={{
                                    border: `2px solid ${isdark === "light"
                                        ? iscolour?.Colour8
                                        : iscolourDark?.Colour12
                                        }`,
                                    background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                                    borderRadius: "18px",
                                }}
                            >

                                <div
                                    className="text-center mb-3"
                                    style={{
                                        background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
                                        color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2,
                                        padding: "12px",
                                        borderRadius: "12px",
                                        fontWeight: "700"
                                    }}
                                >
                                    BALANCE
                                </div>

                                <button
                                    onClick={() => setActivePage("Balance365")}
                                    className="w-100 mb-2 hover-scale-btn"
                                    style={getBtnStyle("Balance365")}
                                >
                                    BALANCE 365
                                </button>

                                <button
                                    onClick={() => setActivePage("BalanceQuality")}
                                    className="w-100 mb-2 hover-scale-btn"
                                    style={getBtnStyle("BalanceQuality")}
                                >
                                    BALANCE QTY
                                </button>

                                <button
                                    onClick={() => setActivePage("BalanceDetail")}
                                    className="w-100 hover-scale-btn"
                                    style={getBtnStyle("BalanceDetail")}
                                >
                                    BALANCE DETAIL
                                </button>

                            </div>
                        </Col>

                    </Row>

                    {filters.production === "" ? (
                        <h3
                            className="text-center text-lg font-semibold pt-5"
                            style={{
                                color:
                                    isdark === "light"
                                        ? iscolour?.Colour2
                                        : iscolourDark?.Colour2,
                            }}
                        >
                            Please choose a master from the list before continuing.
                        </h3>

                    ) : filters.account === "" ? (

                        <h3
                            className="text-center text-lg font-semibold pt-5"
                            style={{
                                color:
                                    isdark === "light"
                                        ? iscolour?.Colour2
                                        : iscolourDark?.Colour2,
                            }}
                        >
                            You must select an account to continue.
                        </h3>

                    ) : !InwParty365Data ? (

                        <div className="flex justify-center items-center w-full min-h-[300px]">
                            <Loader />
                        </div>

                    ) : (

                        <>
                            <Row className="mt-4">

                                <div>

                                    {/* ACCOUNT INFO CARD */}
                                    {showAccountCard && (
                                        <Col className="mb-3">
                                            {renderAccountInfoCard()}
                                        </Col>
                                    )}

                                    {/* SUMMARY CARD */}
                                    {showAccountSummary && (
                                        <Col className="mb-3">
                                            {AccountSummaryCard()}
                                        </Col>
                                    )}

                                    {/* PAGE RENDER */}
                                    <Col>
                                        {renderPage()}
                                    </Col>

                                </div>

                            </Row>
                        </>
                    )}

                </Col>

            </Row >
        </div >
    )
}
